import React from 'react';
import SelectCompressionMode from './SelectCompressionMode';
import DownloadZip from './DownloadZip';
import UploadButton from './UploadButton';

const ActionBarMobile = () => {
	const width = window.innerWidth < 401 ? 120 : 140;
	return (
		<div className="action-bar">
			<div className="action-bar-mobile-upload">
				<UploadButton type="link" icon="plus" text="UPLOAD IMAGES" />
			</div>
			<div className="action-bar-groups">
				<div className="action-group">
					<SelectCompressionMode width={width} />
				</div>
				<div className="action-group download-zip">
					<DownloadZip type="primary" />
				</div>
			</div>
		</div>
	);
};

export default ActionBarMobile;



// WEBPACK FOOTER //
// ./src/components/ActionBarMobile.js